import styled from 'styled-components';

import { TextBodyBold, TextBodySmallNormal } from '@/core/components/Typography/Typography.styles';

export const MediaCardButton = styled.button`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  margin: 0;
  outline: none;
  border: none;
  border-radius: 8px;
  padding: 12px;
  background-color: ${({ theme }) => theme.colors.background.dark};
  color: ${({ theme }) => theme.colors.primaryText};
  text-align: left;
  transition: background-color 150ms ease;
  gap: 12px;
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.colors.background.light};
  }
`;

export const Thumbnail = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
  aspect-ratio: 16 / 9;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors.background.extraLight};
  background-image: repeating-conic-gradient(
    ${({ theme }) => theme.colors.background.light} 0% 25%,
    transparent 0% 50%
  );
  background-size: 16px 16px;
`;

export const ThumbnailImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
  gap: 8px;
`;

export const Title = styled(TextBodyBold)`
  overflow: hidden;
  display: -webkit-box;
  margin: 0;
  font-size: 16px;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;

export const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
`;

export const TimeAgo = styled(TextBodySmallNormal)`
  flex-shrink: 0;
  white-space: nowrap;
`;
